import { render } from "./EditPvsConfiguration.vue?vue&type=template&id=02f11e08&scoped=true&ts=true"
import script from "./EditPvsConfiguration.vue?vue&type=script&lang=ts"
export * from "./EditPvsConfiguration.vue?vue&type=script&lang=ts"

import "./EditPvsConfiguration.vue?vue&type=style&index=0&id=02f11e08&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f11e08"]])

export default __exports__